<template>
  <div>
    <mt-header title="预约信息">
      <router-link to="/mine" slot="left">返回</router-link>
    </mt-header>

    <div class="exp-head">
      当前状态:
      <span style="font-weight:600">已预约</span>
    </div>

    <appoint-info v-if="dataObj" :dataObj="dataObj"></appoint-info>

    <div class="btn-wrap">
      <div @click="preendHandle" class="btn-item gray">提前结束体验</div>
      <div @click="linkTo" class="btn-item blue">延长体验时间</div>
    </div>
  </div>
</template>
<script>
import { myorderdetail, cancel, preend } from "@/api/api";
import {
  formatDate,
  formatStartTimeTips,
  formatEndTimeTips,
  allTime,
} from "@/utils/util";
import { Toast, Indicator } from "mint-ui";
import appointInfo from "@/components/appointInfo";
export default {
  data() {
    return {
      dataObj: "",
    };
  },
  components: {
    appointInfo,
  },

  mounted() {
    let log_id = this.$route.query.logId;
    myorderdetail({
      log_id,
    }).then((res) => {
      this.dataObj = res;
      this.dataObj["date"] = formatDate(this.dataObj.day);
      this.dataObj["startTime"] = formatStartTimeTips(this.dataObj.start_time);
      this.dataObj["endTime"] = formatEndTimeTips(this.dataObj.end_time);
      this.dataObj["allTime"] = allTime(
        this.dataObj.start_time,
        this.dataObj.end_time
      );
    });
  },

  methods: {
    preendHandle() {
      this.$messagebox({
        title: "提示",
        message: "是否提前结束体验",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((action) => {
        if (action == "confirm") {
          preend({
            log_id: this.$route.query.logId,
          }).then((res) => {
            Toast("成功");
            setTimeout(() => {
              this.$router.replace("/mine");
            }, 800);
          });
        } else {
        }
      });
    },
    linkTo() {
      this.$router.push({
        path: "/applyNoDelay",
        query: {
          deviceId: this.dataObj.device_id,
          day: this.dataObj.day,
          logId: this.$route.query.logId,
        },
      });
    },
    selectDay() {
      console.log(this.selected, "11");
    },
    seatClick(index) {
      this.seatList[index].hasChoose = !this.seatList[index].hasChoose;
    },
  },
};
</script>
<style lang="less" scoped>
.exp-head {
  padding: 20px;
  font-size: 0.35rem;
}

.exp-wrap {
  width: 100%;
  padding: 20px;

  .exp-info-wrap {
    background-color: #006feb;
    padding: 40px;
    border-radius: 20px;

    font-size: 0.35rem;
    color: #fff;
    .exp-info {
      .info-item {
        padding: 10px 0;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}

.btn-wrap {
  margin-top: 100px;
  display: flex;
  justify-content: space-around;
  .btn-item {
    width: 40%;
    height: 80px;
    border-radius: 10px;

    font-size: 0.35rem;
    text-align: center;
    color: #fff;
    line-height: 80px;
  }
}
.gray {
  background: rgb(190, 190, 190);
}
.blue {
  background: #006feb;
}
</style>